module.exports = __webpack_public_path__ + "img/dateicon.2c1184ff.svg";